import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
//* Used from July 1st
// import DateRangePicker from "@wojtekmaj/react-daterange-picker";
// import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
// import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
//* Used before July 1st
import { DatePicker, DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "react-calendar/dist/Calendar.css";
import Select from "react-select";
import {dateFilters} from "../../../../constants/constants";
import {
  selectDateFilter,
  getToday,
  formatUTC,
} from "../../../../util/helpers";
import PatientActionButton from "../PatientComponents/PatientActionButton";
import { ReactComponent as DownloadProfile } from "../../../../assets/icons/DownloadProfile.svg";

const DateRangeComponent = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  dateFilterValue,
  setDateFilterValue,
 setFilterSource,
 currentTab,
 setDownloadMode
}) => {
  const [value, setValue] = useState([new Date(startDate), new Date(endDate)]);
  const [selectedDateFilter1, setSelectedDateFilter] = useState(dateFilters[5]);
  const { afterToday } = DateRangePicker;
  useEffect(() => {
    selectDateFilter(selectedDateFilter1?.value,getToday(),endDate,setStartDate,setEndDate);
    setDateFilterValue(selectedDateFilter1?.value);
  }, [selectedDateFilter1]);

  return (
    <div className="w-100 d-flex justify-content-between" style={{ gap: "15px", margin: "0px" }}>
      <div className="d-flex"  style={{ margin: "0px", padding: "0px", width: "100%", gap: "15px" }}>
      {/* Filter on the basis of start date and end date */}
      <DateRangePicker
        ranges={[]}
        showOneCalendar
        appearance="subtle"
        className="custom-datepicker-single"
        placeholder="Today"
        value={[formatUTC(value[0], true), formatUTC(value[1], true)]}
        onChange={(e) => {
          setStartDate(moment(e[0]).format("YYYY-MM-DD"));
          setEndDate(moment(e[1]).format("YYYY-MM-DD"));
          setValue(e);
          setFilterSource('range');
        }}
        character=">"
        cleanable={false}
        isoWeek={true}
        shouldDisableDate={afterToday()}
        locale={{
          sunday: "Su",
          monday: "Mo",
          tuesday: "Tu",
          wednesday: "We",
          thursday: "Th",
          friday: "Fr",
          saturday: "Sa",
          ok: "OK",
          today: "Today",
          yesterday: "Yesterday",
          last7Days: "Last 7 days",
          formattedMonthPattern: "MMM, yyyy",
          formattedDayPattern: "MMM dd, yyyy",
        }}
        format="MM/dd/yyyy"
      />
      
      {/* Filter on the basis of -> [this week,past week,1 month,3 month,6 month] */}
      <div style={{ width: "15%" }}>
        <Select
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              border: "1px solid #CBD5E1",
              boxShadow: "0px 4px 3px rgba(232, 237, 242, 0.65)",
              borderRadius: "8px",
              padding: "5px",
            }),
          }}
          components={{
            IndicatorSeparator: () => null,
          }}
          placeholder="Select"
          classNamePrefix="select"
          name="timePeriod"
          value={selectedDateFilter1}
          onChange={(e) => {
            setSelectedDateFilter(e);
            setDateFilterValue(e.value);
            setFilterSource('preset');
          }}
          options={dateFilters}
          defaultValue={dateFilters[5]}
        />
      </div>
        
      </div>
      {currentTab == 1 && <PatientActionButton
        icon={<DownloadProfile />}
        text={"Download Patient Snapshot"}
        callBack={() => {
          setDownloadMode(true);
          // if (window.location.origin === "http://localhost:3000") {
          //   //* Developer mode only
          // } else {
          //   notify("This feature is coming soon!", "info");
          // }
        }}
        styles={{ width:"280px" }}
      />}
    </div>
  );
};

export default React.memo(DateRangeComponent);
